import { LicenseInfo } from "@mui/x-license-pro";

// Fallback key used when no environment variable is provided (e.g. local dev).
// Prefer setting REACT_APP_MUI_LICENSE_KEY via environment / CI secrets.
const FALLBACK_LICENSE_KEY =
  "6a221b72efd67f50a5ac302cb94e0ff1Tz0xMjAzNzEsRT0xNzk0MDA5NTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=";

const licenseKey =
  process.env.REACT_APP_MUI_LICENSE_KEY ||
  process.env.REACT_APP_MUI_LICENSE ||
  FALLBACK_LICENSE_KEY;

LicenseInfo.setLicenseKey(licenseKey);
